module.exports = __webpack_public_path__ + "img/magnetism-desktop.b250d324.jpg";